export default __webpack_public_path__ + "static/media/foto11_pexels-brady-knoll-6108074.9d89936b.jpg";